export const languageHashValues= {
  "GLOBAL": ".41123e6b4ad80cc95c43",
  "U4302_TRANSACTIONSDETAIL": ".617c6fb3ca06d3a69214",
  "U4400_PAYMENT": ".a6388854ca64d0164e9c",
  "U5122_INVOICEMODIFICATIONAPPROVAL": ".9a6fc28b13f35df02760",
  "U2117_PADAGREEMENTINVITATION": ".d4ce072cbbf2740f3299",
  "U2000_PAD": ".5ccf6867f35e3ea53271",
  "U4402_INVOICEPORTALPAYMENT": ".e614647af89c0738e19e",
  "U2000_BANKACCOUNTCREATION": ".e8c3a6bdefa0fd0efa25",
  "U2011_LOGIN": ".53267b99ff594eed1357",
  "U2012_LOGINHELP": ".99da4e82ad97e4e0fac1",
  "U2014_SECURITY": ".31e67c73aaab571be44b",
  "U2086_EFTPENDINGPAYMENTS": ".2311cdd49c924f108ee6",
  "U2087_EFTPAYMENTSNOTIFICATIONS": ".321abdef4713167eb552",
  "U2110_ACCOUNTCREATION": ".47360bb1631e374b08b6",
  "U2121_INDIVIDUALPROFILE": ".1cbaa9fc756b43e0bb0e",
  "U2131_ORGANIZATIONPROFILE": ".e4499a67ef768fcc2732",
  "U2112_ERPBINDING": ".16529747a6c2132a9fe3",
  "U2113_SUPPLIERINVITATION": ".c1560e1586c89718df58",
  "U2132_AFFILIATION": ".01fec136ebbb33dcfdf4",
  "U2133_BUSINESSLINKS": ".48ac14875bfba598591a",
  "U2181": ".6c63a59dc818f82714bf",
  "U2211_SUBSCRIPTIONOFFER": ".ff5b3650a97cad30a103",
  "U2212_SUBSCRIPTIONFILTER": ".7e3b421d9b28325913fa",
  "U2213_SUBSCRIPTION": ".6044bd25f33edaa3717a",
  "U4111_CREDITCARDADDITION": ".e0ffe7f0eeb591eb6768",
  "U4112_CREDITCARDDETAIL": ".e99080198eb5355cd63d",
  "U4121_BANKACCOUNTADDITION": ".5c169cff50416a45b18a",
  "U4122_BANKACCOUNTDETAIL": ".b8b2dbd04fa76236678c",
  "U4303_ANONYMOUSTRANSACTION": ".69ae17c6e8daa76f8c78",
  "U4401_PAYMENTGATEWAY": ".b6489aa7b1208fe67671",
  "U4481_PROCESSINVOICEINSTALMENTPAYMENTS": ".ef4c3509c451da5fd600",
  "U5000_RECEIVABLE": ".3b80a28698343a560b43",
  "U5101_STATEMENTOFACCOUNT": ".64ded914b0dab3e29870",
  "U5102_INVOICE": ".b636882d52bac6059702",
  "U5103_PADAGREEMENT": ".c49cb482b1b129fc231a",
  "U5121_SENTINVOICE": ".209781bab18418e48f04",
  "U5124_PGRECEIVEDPAYMENT": ".b8b6bbed83d2b7ad5c44",
  "U5120_INVOICES": ".01c096805b3ad9c01f54",
  "U5123_PADAGREEMENTCONSOLE": ".a8495c416fa116f425d7",
  "U5132_PAYMENTRECONCILIATION": ".d7b8b716adc707268361",
  "U5133_BANKRECONCILIATION": ".12a30a99f61458b21184",
  "U6112_BUSINESSLINK": ".64c735e3cc8d0bf4f008",
  "U6113_SUPPLIERRECORD": ".bc34e0c564675f1f22e1",
  "U6211_PAYLOT": ".b090f661522ba53f0333",
  "U6311_PURCHASE": ".36a5d65abf9872e0c809",
  "U2115_AFFILIATIONINVITATION": ".65a9eec533818db82e9d",
  "U6100_PAYABLE": ".0f714143864a8b5a0f5d",
  "U6131_SENTPAYMENT": ".04c23447dedb2ecf4019",
  "U6191_SENTPAYMENTREPORT": ".57120a6280a914115845",
  "U6221_SENTPAYMENT": ".f30f359b00fa050bf754",
  "U6422_INTERACSENTPAYMENT": ".8c099ab4cb155b7907a8",
  "U6531_TRANSACTIONPAYMENT": ".b2b48d426cf84963828d",
  "U5131_RECEIVEDPAYMENT": ".ba6418dd0828b5c9cc79",
  "U5191_RECEIVEDPAYMENTREPORT": ".c0bcf998c1962171903b",
  "U6141_INVOICEDATA": ".05385dffa67475912d8e",
  "U6142_INVOICEDATA": ".0d654d570de05b0e0e3a",
  "U2001_HOME": ".f549a0e2865cc1d0b498",
  "U2024_REPORTLOG": ".dec8c0aa85bc86e95347",
  "U2111_INVOICEPORTALBINDING": ".6e55f7b5e08f11c039a3",
  "U2116_ANONYMOUSSUPPLIERINVITATION": ".f10d18eebb5ff540f0c8",
  "U6111_SUPPLIERINVITATIONCONSOLE": ".6d681ff4d2a654aa9d43",
  "U6511_TRANSACTIONPARTY": ".567e15e64965a9272cec",
  "U6212_PAYROLLPARTY": ".2c104e347c11f44777a0",
  "U6121_EFTLOT": ".4068d5c29646509a2ac2",
  "U6412_INTERACFILE": ".0e17ec181e9382ff78f9",
  "U6122_EFTAPPROVAL": ".09e815c68fbe5821e4fc",
  "U6512_TRANSACTIONLOT": ".7584c9e8497a2b200eec",
  "U2027_EFTLOT": ".0041db9cf911db951135",
  "U6123_EFTAPPROVAL": ".2099e9617adf70d2ea72",
  "U6123_EFTAPPROVALMOBILE": ".6aeb21ae25f8895dc128",
  "U2012_LOGIN": ".15a54544e19479d33846",
  "U6611_RESELLERCLIENT": ".7cbc9c78fc636dfd61a9",
  "U2000_PAYMENT": ".a127e97b624cf1645e1f",
  "U4101_CREDITCARDBANKACCOUNTSUMMARY": ".8cb1013b85bf2a2cd0fe",
  "U2000_PAYMENTMODEUPDATE": ".eef0b5af0c9f572649a7",
  "U6114_TELUSBILLER": ".ca327c2f4232e75f5a7a",
  "U4403_CREDITCARDTERMINAL": ".e11d553d03ad7dd7607d",
  "U4404_INTERACTERMINAL": ".eb71acb4aaf7f204df44",
  "U2000_SAMPLECHEQUESELECTION": ".d129d6be6aed0d81e5d2",
  "U2023_TUTORIALVIDEO": ".d3037a99d49e99fd55a6",
  "U2134_ORGANIZATIONBILLING": ".11945f4fa96500cabf89",
  "U6414_BANKACCOUNTWALLET": ".57aad565831f4fe939fd",
  "U2022_INSTANTACCOUNTVERIFICATION": ".fe2dcb2646510cef9af0",
  "U6532_PENDINGTRANSACTION": ".5828bb316244bad7303a",
  "U4301_TRANSACTIONSSUMMARY": ".c7fc0cb4a5a413f71105",
  "U2026_NETPROMOTERSCORE": ".55a9473630340bbc287c",
  "U2000_ACCOUNTPERSONNALINFORMATIONS": ".ac503d27f3394375781a",
  "U2000_INTRO": ".e5f34609c390c3ac20cd",
  "U2000_ATTACHMENTVIEWER": ".173dbd285e71c82068c0",
  "U2000_ELECTRONICSIGNATURE": ".c2e62ffc7b1ea700bbc2",
  "U2000_VERIFYEMAIL": ".67c84532f9274d3834fa",
  "U2200_SUBSCRIPTION": ".b11126866e9fbabf3d6e",
  "U2118_RBBINDING": ".b469ea668d44e9572496",
  "U2028_RELEASENOTE": ".f1c52dcd40b5b6d230be",
  "U2000_VERIFYIDENTITY": ".39ebd1c8ce7774f206ba",
  "U2212_PLANLIST": ".cf3e7d70c773857c0347",
  "U3002_TAXBILLSEARCHRESULT": ".7098921671cd9a41ff12"
}